import { LoginService } from './../../services/login/login.service';
import { Component } from '@angular/core';

@Component({
  selector: 'app-negociaciones',
  templateUrl: './negociaciones.component.html',
  styleUrls: ['./negociaciones.component.scss']
})
export class NegociacionesComponent {

  abrirNuevoReprogramacion : boolean = false;
  abrirNuevoJudicial : boolean = false;
  deuda : any;
  constructor(private loginService:LoginService){}

  clickGuard(){
      this.loginService.clickGuard = true;
  }

  nuevoReprogramacion(){
      this.abrirNuevoReprogramacion = true;
  }

  cerrarPopUpReprogramacion(Click:boolean){
      this.abrirNuevoReprogramacion = false;
  }

  nuevoJudicial(){
      this.abrirNuevoJudicial = true;
  }

  cerrarPopUpJudicial(Click:boolean){
      this.abrirNuevoJudicial = false;
  }

}
